<script>
    import TextInput from './TextInput';
    export default {
        mixins: [TextInput],
        data() {
            return {
                inputType: 'password'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/src/components/Form/Inputs/PasswordInput.vue